var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('token-stepup',{staticClass:"isotope-step-up-category--totp",attrs:{"stepUpCategory":_vm.stepUpCategory,"tokenLength":6}})}
var staticRenderFns = []

export { render, staticRenderFns }